import { FilterOptions } from "@/types/FilterOptions";
import { SearchFilterV4 } from "@/types/SearchFilter";
import { Checkbox } from "@components/ui/checkbox";
import {
  CommandGroup,
  CommandItem,
  CommandSeparator,
} from "@components/ui/command";
import { Trans } from "@lingui/react/macro";
import { ChevronLeftIcon } from "lucide-react";

export default function PageSentiments({
  options,
  onChange,
  value,
  onBack,
}: {
  onChange: (value: SearchFilterV4, clear?: boolean) => void;
  value: SearchFilterV4["sentiment"];
  options: FilterOptions["filter_sentiments"];
  onBack?: () => void;
}) {
  // Helpers
  const isArray = Array.isArray(value);

  const isAllSelected = isArray && value.length === options.length;

  return (
    <>
      {onBack && (
        <>
          <CommandGroup>
            <CommandItem onSelect={onBack}>
              <ChevronLeftIcon />
              <Trans>Tillbaka</Trans>
            </CommandItem>
          </CommandGroup>

          <CommandSeparator />
        </>
      )}

      <CommandGroup>
        {isAllSelected ? (
          <CommandItem
            onSelect={() => {
              onChange({
                sentiment: undefined,
              });
            }}
          >
            <Trans>Avmarkera alla</Trans>
          </CommandItem>
        ) : (
          <CommandItem
            onSelect={() => {
              onChange({
                sentiment: options.map(([value]) => value),
              });
            }}
          >
            <Trans>Markera alla</Trans>
          </CommandItem>
        )}
      </CommandGroup>

      <CommandSeparator />

      <CommandGroup>
        {options.map(([sentiment, label]) => {
          const isChecked = isArray
            ? value.includes(sentiment)
            : value === sentiment;

          return (
            <CommandItem
              key={sentiment}
              onSelect={() => {
                if (isChecked) {
                  onChange({
                    sentiment: isArray
                      ? value.filter((it) => it !== sentiment)
                      : undefined,
                  });
                } else {
                  onChange({
                    sentiment: isArray
                      ? [...value, sentiment]
                      : value
                        ? [value, sentiment]
                        : [sentiment],
                  });
                }
              }}
            >
              <Checkbox checked={isChecked} className="pointer-events-none" />
              {label}
            </CommandItem>
          );
        })}
      </CommandGroup>
    </>
  );
}
